import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import messages from 'shared/constants/messages';
import { useDispatch } from 'react-redux';
import { AuthActionType } from 'store/actionTypes/auth-action-type';

const ServiceUnavailable: React.FC = () => {
    const dispatch = useDispatch();

    const handleRefreshPage = () => {
        dispatch({ type: AuthActionType.SET_SERVICE_DOWN, payload: false });
        window.location.reload();
    };

    return (
        <Box height="90vh" display="flex" alignItems="center" justifyContent="center">
            <Box textAlign="center">
                <Typography variant="h4" className="p-0">
                    Service Unavailable
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    {messages.SomethingWentWrong}
                </Typography>
                <Box display="flex" justifyContent="center">
                    <Button className="btn" variant="contained" color="primary" onClick={handleRefreshPage}>
                        Refresh Page
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default ServiceUnavailable;
